import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Accordion from '../../../../components/Accordion';
import Select from '../../../../components/Inputs/Select';
import Input from '../../../../components/Inputs/Input';
import { EmptyField } from '../../../../components/Inputs/styles';
import StepProgress from '../../../../components/StepProgress';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';
import DependentsDetails from '../../../../components/Cards/DependentsDetails';
import FormContainer from '../../../../components/FormContainer';
import Divider from '../../../../components/Divider';
import PageLoader from '../../../../components/PageLoader';

import steps from '../../../../utils/steps.json';
import schema from './schema';

import validators from '../../../../utils/defaultValidators';
import validate from '../../../../utils/validateForm';

import Modal from '../../../../components/Modal';

import {
    trocarPlano,
    buscaBeneficiarioTransferenciaFamilia,
    getCongenerByContractAndPlanAndUfAndCity,
    getStates,
    getCities,
} from '../../../../services';
import { getCongenerByContractAndPlan } from '../../../../services/v3/contrato-congenere';

import { checkIsSupport, cloneObject, handleTopCritics } from '../../../../utils';

import { useGlobal } from '../../../../contexts/Global/context';

import * as S from './styles';
import { PageContainer } from '../../../../styles/styles';

function Dependente({ location: { dataBeneficiario, dataMovimentacaoPendente, criticas } }) {
    const history = useHistory();
    const { dataActiveContract, setShowSupportModal } = useGlobal();
    const [dataForm, setDataForm] = useState(dataMovimentacaoPendente || cloneObject(schema));
    const [dataBeneficiarioFamilia, setDataBeneficiarioFamilia] = useState({});
    const [adressService, setAdressService] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);
    const [dataCongener, setDataCongener] = useState({});
    const [congenerContract, setCongenerContract] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [sugestedDate, setSugestedDate] = useState(false);
    if (criticas != null) {
        useEffect(() => {
            setAlerts([...criticas]);
        }, []);
    }

    function mapStateOptions(results) {
        return results.map(({ descricaoUf, idUf }) => ({
            codigo: idUf,
            nome: descricaoUf,
        }));
    }

    function mapCityOptions(results) {
        return results.map(({ descricaoMunicipio, idMunicipio }) => ({
            codigo: idMunicipio,
            nome: descricaoMunicipio,
        }));
    }

    async function getCongenereStates(numeroContrato, codigoPlano) {
        const { results } = await getCongenerByContractAndPlan({ numeroContrato, codigoPlano });
        setCongenerContract(results);

        const states = new Set();

        await Promise.all(
            results.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getStates({ idContratoCongenere: numeroContratoCongenere });
                if (congenere?.estados) {
                    congenere.estados.forEach((estado) => {
                        states.add(JSON.stringify(estado));
                    });
                }
            })
        );
        return Array.from(states)
            .map((state) => JSON.parse(state))
            .flat();
    }

    async function getCongenereCities(idUf) {
        if (!congenerContract) return [];

        const cities = new Set();

        await Promise.all(
            congenerContract.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getCities({ idContratoCongenere: numeroContratoCongenere, idUf });
                if (congenere?.municipios) {
                    congenere.municipios.forEach((municipio) => {
                        cities.add(JSON.stringify(municipio));
                    });
                }
            })
        );
        return Array.from(cities)
            .map((city) => JSON.parse(city))
            .flat();
    }

    async function updateCongenerName() {
        const { results } =
            (await getCongenerByContractAndPlanAndUfAndCity({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataForm?.newHealthPlan?.value,
                siglaUf: dataForm?.state?.value,
                codigoMunicipio: dataForm?.city?.value,
            })) || [];

        const [{ nomeFantasiaCongenere }] = results?.length ? results : [{ nomeFantasiaCongenere: '' }];

        setDataCongener({ ...dataCongener, new: nomeFantasiaCongenere });
    }

    useEffect(() => {
        setDataCongener({ ...dataCongener, new: '' });

        if (dataForm.state.value && dataForm.city.value && dataForm.newHealthPlan.value) {
            updateCongenerName();
        }
    }, [dataForm.state.value, dataForm.city.value, dataForm.newHealthPlan.value]);

    useEffect(() => {
        if (!dataBeneficiario) history.push('/movimentacao_cadastral/selecionar_trocar_plano');

        async function loadData() {
            setPageLoading(true);

            const { ufAtendimento, nomeMunicipioAtendimento, codigoMunicipioAtendimento } = dataBeneficiario;

            const responseFamilia =
                (await buscaBeneficiarioTransferenciaFamilia(
                    dataBeneficiario.carteirinha,
                    dataActiveContract.numero
                )) || {};

            let results;

            if (ufAtendimento && codigoMunicipioAtendimento) {
                results = await getCongenerByContractAndPlanAndUfAndCity({
                    numeroContrato: dataActiveContract?.numero,
                    codigoPlano: responseFamilia?.plano.codigo,
                    siglaUf: ufAtendimento,
                    codigoMunicipio: codigoMunicipioAtendimento,
                });
            } else {
                results = await getCongenerByContractAndPlan({
                    numeroContrato: dataActiveContract?.numero,
                    codigoPlano: responseFamilia?.plano.codigo,
                });
            }

            if (results?.results?.length) results = results.results;

            const [{ nomeFantasiaCongenere }] = results.length ? results : [{ nomeFantasiaCongenere: '' }];

            setDataCongener({ ...dataCongener, actual: nomeFantasiaCongenere });

            setAdressService({ ufAtendimento, nomeMunicipioAtendimento });

            if (responseFamilia) setDataBeneficiarioFamilia(responseFamilia);

            const planosFiltered = dataBeneficiario.novosPlanos
                .filter((plano) => plano.codigo !== responseFamilia?.plano?.codigo)
                .map((plan) => ({ ...plan, nome: `${plan.codigo} - ${plan.nome}` }));

            const uniquePlans = [];

            planosFiltered.forEach((plano) => {
                const planAlreadyExists = uniquePlans.find((plan) => plan.codigo === plano.codigo);

                if (!planAlreadyExists?.codigo) {
                    uniquePlans.push(plano);
                }
            });

            setDataForm({
                ...dataForm,
                newHealthPlan: { ...dataForm.newHealthPlan, options: uniquePlans },
                date: {
                    ...dataForm.date,
                    value: dataActiveContract.referenciaMovimentacao.dataReferenciaMovimentacao,
                },
            });
            setPageLoading(false);
        }
        loadData();
    }, []);

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        if (key === 'birth' && value) {
            form.dn.error = '';

            if (form.dn.value) validators.dn(form);
        }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup } = event;

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
        };

        let newDataForm = {
            ...dataForm,
            [id]: field,
        };

        const city = cloneObject(dataForm.city);
        const state = cloneObject(dataForm.state);

        if (id === 'newHealthPlan') {
            const statesCongener = await getCongenereStates(dataActiveContract.numero, value);

            state.options = mapStateOptions(statesCongener) || [];
            state.value = '';
            state.error = '';
            city.value = '';
            city.error = '';

            newDataForm = { ...newDataForm, state, city };
        }

        if (id === 'state') {
            const municipios = value ? (await getCongenereCities(value)) || [] : [];

            city.options = mapCityOptions(municipios);
            city.value = '';
            city.lookup = '';
            newDataForm = { ...newDataForm, city };
        }

        setDataForm(newDataForm);
    }

    async function handleSendDataBeneficiario() {
        setLoadingPost(true);

        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const payload = {
            codigoTSContrato: dataBeneficiarioFamilia.contrato.codigoTs,
            numeroContrato: dataBeneficiarioFamilia.contrato.numero,
            numeroAssociadoOuNumeroCarteiraTitular: dataBeneficiario.carteirinha,
            codigoPlanoAntigo: dataBeneficiarioFamilia.plano.codigo,
            codigoPlanoNovo: dataForm.newHealthPlan.value,
            codigoMunicipio: dataForm.city.value,
            dataMigracao: dataForm.date.value,
            abrangencia: 'D',
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        };

        const response = (await trocarPlano(payload)) || {};

        if (!response || response?.errorDescription || response[0]?.errorDescription) {
            response.movimentacoes = [
                {
                    criticas: [
                        {
                            tipo: 1,
                            descricao: response?.errorDescription || response[0]?.errorDescription || 'Erro de API',
                        },
                    ],
                },
            ];
        }

        const movimentacao = response?.movimentacoes[0];
        const criticasTratadas = handleTopCritics(movimentacao.criticas);

        if (criticasTratadas.length > 0) {
            setAlerts([...criticasTratadas]);

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setLoadingPost(false);

            return;
        }

        history.push('/movimentacao_cadastral/validar_trocar_plano');
    }

    return (
        <PageContainer>
            <StepProgress steps={steps.alterarBeneficiario} activeStep={2} />

            {alerts.map((alert, index) => (
                <Alert key={() => index} type={alert.tipo} title={alert.descricao} message={alert.complemento} />
            ))}

            <Accordion title="Trocar o plano" hasCollapse={false}>
                <FormContainer>
                    <Input
                        field={{
                            id: 'carteirinha',
                            label: 'N° da carteirinha',
                            value: dataBeneficiario?.carteirinha,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'nomeCompleto',
                            label: 'Nome completo',
                            value: dataBeneficiario?.nomeCompleto,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'contrato',
                            label: 'Contrato',
                            value: `${dataBeneficiarioFamilia?.contrato?.numero} - ${dataBeneficiarioFamilia?.contrato?.descricao}`,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'empresa',
                            label: 'Empresa',
                            value: dataBeneficiarioFamilia?.empresa?.nome,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Estado de atendimento',
                            value: adressService?.ufAtendimento,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Município de atendimento',
                            value: adressService?.nomeMunicipioAtendimento,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Congênere',
                            value: dataCongener?.actual,
                            disabled: true,
                        }}
                    />
                </FormContainer>

                <Divider />

                <FormContainer>
                    <Input
                        field={{
                            id: 'planoAtual',
                            label: 'Plano atual',
                            value: `${dataBeneficiarioFamilia?.plano?.codigo} - ${dataBeneficiarioFamilia?.plano?.nome}`,
                            disabled: true,
                        }}
                    />
                    <DatepickerMui
                        field={dataForm.date}
                        onBlur={handleInputBlur}
                        onChange={(event) => {
                            if (event.isValidDate) {
                                setShowModal(true);
                                setModalMessage(
                                    'A vigência indicada está de acordo com o período de cobertura da empresa e, caso seja alterada, poderá acarretar cobrança retroativa do valor integral da mensalidade do beneficiário.'
                                );
                            }
                            setSugestedDate(event.value);
                            handleChangeInput(event);
                        }}
                    />
                    <Select field={dataForm.newHealthPlan} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <EmptyField />
                    <Select field={dataForm.state} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select
                        field={{ ...dataForm.city, disabled: !dataForm.state.value }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    {dataCongener?.new && (
                        <Input
                            field={{
                                label: 'Congênere',
                                value: dataCongener?.new,
                                disabled: true,
                            }}
                        />
                    )}
                </FormContainer>
            </Accordion>

            {dataBeneficiarioFamilia?.dependentes?.length > 0 && (
                <DependentsDetails dataBeneficiario={dataBeneficiarioFamilia} />
            )}

            <S.ButtonAlignTp>
                <Button id="backStep" type="secondary" style={{ marginRight: '24px' }} onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingPost}
                    disabled={loadingPost}
                    onClick={handleSendDataBeneficiario}
                >
                    Trocar o plano
                </Button>
            </S.ButtonAlignTp>
            <PageLoader loading={pageLoading} />

            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                closable={false}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <>
                    <Button
                        type="secondary"
                        onClick={() => {
                            setDataForm({
                                ...dataForm,
                                date: {
                                    ...cloneObject({
                                        ...dataForm.date,
                                        value: sugestedDate,
                                    }),
                                },
                            });
                            setShowModal(false);
                        }}
                    >
                        Não quero
                    </Button>

                    <Button
                        type="primary"
                        onClick={() => {
                            setAlerts([
                                ...alerts,
                                {
                                    tipo: 2,
                                    codigo: 'dateStartPlan',
                                    descricao: '',
                                    complemento:
                                        'Você está alterando a data de início do plano. Com essa mudança o valor da próxima fatura terá novos custos.',
                                },
                            ]);
                            setShowModal(false);
                        }}
                    >
                        Quero Alterar
                    </Button>
                </>
            </Modal>
        </PageContainer>
    );
}

export default Dependente;
